const Paragraph = ({ children, className = '' }) => (
  <div className="ParagraphItem css-huenw5">
    <p className={`ql-align-center ${className}`}>{children}</p>
  </div>
);

export default Paragraph;
